import List from "./List"

const Store = {
  namespaced: true,
  modules: {
    List
  }
}

export default Store
